import {
    DataRecordValue,
    DataRecord,
    getColumnLabel,
} from '@superset-ui/core';
import { EChartsCoreOption, MapSeriesOption, VisualMapComponentOption } from 'echarts';

import * as echarts from 'echarts';
import { GeoJSONSourceInput } from 'echarts/types/src/coord/geo/geoTypes';

import centroidForEachCountry, { specialAreas, countries } from '../data/countries';

import {
  DEFAULT_FORM_DATA,
  EchartsMapChartProps,
  EchartsMapFormData,
  MapChartTransformedProps,
  MapDataItemOption,
  tooltipOptions
} from './types';
import {
    extractGroupbyLabel,
} from '../../../utils/series';
import { getMetricSeriesData,getColumnNamePosition, MetricSeriesData } from '../../Bar/utils';

export default function transformProps(
    chartProps: EchartsMapChartProps,
): MapChartTransformedProps {
    const { formData, height, hooks, queriesData, width } =
      chartProps;
    const data: DataRecord[] = queriesData[0].data || [];
   
    const {
      groupby,
      showDbhdsRegion,
      metrics,
      combineMetrics,
      selectCountry,
      showGoldStandard,
      dbhdsRegion,
      goldStandardCondition,
      enablePopUpDrilldown,
      popUpGroupBy,
      popUpMetrics,
      popUpDropdownColumns,
      columnConfig
    }: EchartsMapFormData = {
      ...DEFAULT_FORM_DATA,
      ...formData,
    };

    const dimMetrics: any[]=[];
    let rowMetrics: any[]=[];
    
    const checkIfGoldStandard = (record: any) => {
      const { subject, comparator , operator } = goldStandardCondition[0];
      const value = record[subject];
      if (operator === "==") {
        if (String(value) === String(comparator)) {
          return true;
        }
      }
      return false;
    };

    const computeGoldStandardCounties = ():string[] => {
      const counties =  data.filter(record => {
              return checkIfGoldStandard(record);
      }).map(record => record[String(groupby)] as string);
      return counties;
    };
    
    const goldStandardCounties: string[] = showGoldStandard ? computeGoldStandardCounties(): [];

    const groupbyLabels = Array.isArray(groupby) ? groupby.map(getColumnLabel)
      : [groupby].map(getColumnLabel);

    const labelMap = data.reduce(
      (acc: Record<string, DataRecordValue[]>, datum) => {
        const label = extractGroupbyLabel({
          datum,
          groupby: groupbyLabels,
          coltypeMapping: {},
        });
        return {
          ...acc,
          [label]: groupbyLabels.map(col => datum[col]),
        };
      },
      {},
    );
  
    const { setDataMask = () => {} } = hooks;
    let dbdhsRegionIndex=0;
    if (showDbhdsRegion && showGoldStandard){
      dbdhsRegionIndex=getColumnNamePosition(metrics || [],dbhdsRegion);
    }
    const multiMetricData: MetricSeriesData = getMetricSeriesData(metrics || [], data, combineMetrics);
    if (countries[selectCountry].type === 'str') {
      echarts.registerMap(selectCountry, JSON.parse(countries[selectCountry].data) as GeoJSONSourceInput,
        specialAreas[selectCountry] ? specialAreas[selectCountry] : undefined);
    } else if (countries[selectCountry].type === 'json') {
      echarts.registerMap(selectCountry, countries[selectCountry].data as GeoJSONSourceInput,
        specialAreas[selectCountry] ? specialAreas[selectCountry] : undefined);
    }

    const visualMap: VisualMapComponentOption[] = [];
    const series: MapSeriesOption[] = Object.values(multiMetricData).map((metricData, index) => {
      // let seriesMin = NaN;
      // let seriesMax = NaN;
      // let seriesSum = 0;
      
      const metricLabel = metricData.name;
      const seriesData = data.map(datum => {
        const label = extractGroupbyLabel({
          datum,
          groupby: groupbyLabels,
          coltypeMapping: {},
        });
  
        // seriesMin = !Number.isNaN(seriesMin) ?
        //   Math.min(seriesMin, number.numericToNumber(datum[metricLabel]))
        //   : number.numericToNumber(datum[metricLabel]);
        // seriesMax = !Number.isNaN(seriesMax) ?
        //   Math.max(seriesMax, number.numericToNumber(datum[metricLabel]))
        //   : number.numericToNumber(datum[metricLabel]);
        // seriesSum += number.numericToNumber(datum[metricLabel]);
        
        return {
          name: label,
          value: datum[metricLabel]
        };
      });

      // const seriesMinInteger = Math.floor(seriesMin);
      // const seriesMaxInteger = Math.ceil(seriesMax);

      visualMap.push({
        seriesIndex: index,
        show: false,
        left: 'right',
        // min: seriesMinInteger === seriesMaxInteger ? seriesMinInteger - 1 : seriesMinInteger,
        // max: seriesMaxInteger,
        // inRange: {
        //   color: [...DEFAULT_FORM_DATA.colorRange]
        // },
        inRange: {
          color: [DEFAULT_FORM_DATA.colorRange[0]] // Replace '#ff0000' with your desired color
        },
        text: ['High', 'Low'],
        calculable: true,
      });
      
      return {
        name: metricLabel,
        type: 'map',
        roam: true,
        geoIndex: 0,
        map: selectCountry,
        animation: true,
        emphasis: {
          label: {
            show: true
          },
        },
        // @ts-ignore
        data: seriesData as OptionDataValue[]
      };
    });
    
  
    /* const series: MapSeriesOption[] = [
      {
        name: metricLabel,
        type: 'map',
        roam: true,
        map: selectCountry,
        animation: true,
        emphasis: {
          label: {
            show: true
          }
        },
        // @ts-ignore
        data: seriesData
      },
    ]; */
    const echartOptions: EChartsCoreOption = {
      toolbox:{show:true,left:'left',top:'top',feature:{restore:{show:true}}},
      tooltip: {
        position: 'bottom',
        trigger: 'item',
        ...tooltipOptions,
        formatter: //  @todo: check from where we get this variable => tooltipFormat?.length > 0
          /* ? tooltipFormat
          :  */(params: any) => {

            if (params.seriesType === 'map') {
              const tooltip = [`${params.name}`];
              series.forEach((serie, index) => {
                  if(serie.type === "map"){
                    const res: any = serie.data?.find((e: any) => e.name === params.name);
                    if(showDbhdsRegion){
                        if(index === dbdhsRegionIndex){
                          tooltip.push(`${serie.name} : ${res && res.value !== null && !Number.isNaN(Number(res.value)) ? Math.round(Number(res.value)).toLocaleString()   : '0'}
  
  `);
                        }else{
                          tooltip.push(`${serie.name} : $${res && res.value !== null && !Number.isNaN(Number(res.value)) ? Math.round(Number(res.value)).toLocaleString()  : '0'}
  `);
                        }
                      }else{
                      tooltip.push(`${serie.name} : $${res && res.value !== null && !Number.isNaN(Number(res.value)) ? Math.round(Number(res.value)).toLocaleString()  : '0'}
  `);
                    }
                }
              });
              // /* if (params.data?.value) {
              //   return `${params.seriesName}<br>${params.name} : ${params.data.value} (${((params.data.value * 100) / seriesSum).toFixed(2)}%)`;
              // }
              // return `${params.seriesName}<br>${params.name} : 0 (0%)`; */
              return tooltip.join('<br>');
              // return `${params.name}<br />Population: ${params.value} <br /> ${params.name}: ${params.value}  <br />`;
            }
            return []
            // return `${params.name}<br />Value: ${params.value}`;
          },
      },
      textStyle:{
        fontFamily:'Merriweather'
      },
      visualMap,
      series,
      geo: {
        map: selectCountry,
        roam: true,
        zoom:1,
        itemStyle: {
          emphasis: {
            color: '#eee'
          }
        }
      },
      graphic: [
        {
          type: 'group',
          id: 'zoomGroup',
          right: 0, // Adjust position
          bottom: 30,
          z: 3,
          children: [
            {
              type: 'text',
              id: 'zoomText',
              top: -40,
              left: 5,
              z: 5,
              style: {
                text: 'Map\nZoom', // Line break for text
                fill: '#272833',
                font: '15px Merriweather',
                textAlign: 'center',
                textVerticalAlign: 'middle',
              },
              tooltip: {
                show: false,
              }
            },
            {
              type: 'rect',
              id: 'zoomRect',
              top: 0,
              left: 0,
              z: 4,
              shape: {
                width: 40,
                height: 120,
                r: 15
              },
              style: {
                fill: '#6B6C7E', // Dark grayish-blue
                stroke: '#D6DEEB',
                lineWidth: 2,
              },
              tooltip: {
                show: false,
              }
            },
            {
              type: 'image',
              id: 'zoomInIcon',
              top: 25,
              z: 5,
              left: 11,
              style: {
                image: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOSAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuMzk5OSA4Ljc3NTM5SDExLjE0OTkiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTkuMjc0OSAxMC42NTA0VjYuOTAwMzkiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTkuMTI1IDE1Ljc1QzEzLjA2IDE1Ljc1IDE2LjI1IDEyLjU2IDE2LjI1IDguNjI1QzE2LjI1IDQuNjg5OTcgMTMuMDYgMS41IDkuMTI1IDEuNUM1LjE4OTk3IDEuNSAyIDQuNjg5OTcgMiA4LjYyNUMyIDEyLjU2IDUuMTg5OTcgMTUuNzUgOS4xMjUgMTUuNzVaIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNyAxNi41TDE0LjUgMTQiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==',
                width: 20,
                height: 20
              },
              tooltip: {
                show: false,
              }
            },
            {
              type: 'line',
              id: 'separatorLine',
              top: 60,
              left: 5,
              z: 5,
              shape: {
                x1: 0,
                y1: 0,
                x2: 27,
                y2: 0
              },
              style: {
                stroke: '#B4BDD3',
                lineWidth: 1.5
              },
              tooltip: {
                show: false,
              }
            },
            {
              type: 'image',
              id: 'zoomOutIcon',
              top: 80,
              z: 5,
              left: 11,
              style: {
                image: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOSAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuMjUgOC43NzUzOUgxMSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNOS4xMjUgMTUuNzVDMTMuMDYgMTUuNzUgMTYuMjUgMTIuNTYgMTYuMjUgOC42MjVDMTYuMjUgNC42ODk5NyAxMy4wNiAxLjUgOS4xMjUgMS41QzUuMTg5OTcgMS41IDIgNC42ODk5NyAyIDguNjI1QzIgMTIuNTYgNS4xODk5NyAxNS43NSA5LjEyNSAxNS43NVoiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE3IDE2LjVMMTQuNSAxNCIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K',
                width: 20,
                height: 20
              },
              tooltip: {
                show: false,
              }
            }
          ]
        }
      ],
    };

     
    function isMapDataItemOption(item: any): item is MapDataItemOption { return typeof item === 'object' && 'value' in item && 'name' in item; }
    
    // Add the case for show dbhds region
    if (showGoldStandard && (!showDbhdsRegion)) {
      // hide the legend
      (echartOptions as any).visualMap[0].show=false;
      console.log('Gold Standard Counties:', goldStandardCounties);
      // Apply an offset to shift the image to the left
      const scatterData = goldStandardCounties.map(county => {
        const coords = centroidForEachCountry[county.toLowerCase()];
        if (coords) {
          console.log(`${county}: Lat ${coords[0]}, Lng ${coords[1]}`);
          return [coords[0] - 0.5, coords[1]]; 
        }
      }).filter(Boolean); 

      (echartOptions.series as any).push({
        type: "scatter",
        symbol: "image://https://www.svgrepo.com/show/13695/star.svg",
        symbolSize: 10,
        color: 'orange',
        geoIndex: 0,
        coordinateSystem: 'geo',
        data: goldStandardCounties.map(county => {
          const coords = centroidForEachCountry[county.toLowerCase()];
          if (!coords) {
            console.log('Missing centroid for county:', county, 'lowercased:', county.toLowerCase());
          }
          return coords ? [coords[1], coords[0]] : null;
        }).filter(Boolean),
       silent: true
      });
    }
    else if(showDbhdsRegion && (!showGoldStandard)){
      // find the index
      
      
      // console.log("info dbhds region index:",dbdhsRegionIndex);
      const noOfCountiesAndCities: number = series?.[0]?.data?.length ?? 0;
      const totalNoOfSeries: number = series.length;
      
  
      for(let eachCountiesAndCities=0;eachCountiesAndCities < noOfCountiesAndCities; eachCountiesAndCities+=1){
        rowMetrics=[];
        for (let eachSeries=0; eachSeries<totalNoOfSeries; eachSeries+=1){
          // name
          if (eachSeries===0){
            const dataItem = series?.[eachSeries]?.data?.[eachCountiesAndCities]; 
            if (isMapDataItemOption(dataItem)) { 
              const name = dataItem.name || ''; 
              rowMetrics.push(name); } 
            else { 
              rowMetrics.push(''); 
            }
          }
          // all the metrics
          const dataItem = series?.[eachSeries]?.data?.[eachCountiesAndCities]; 
          if (isMapDataItemOption(dataItem)) { rowMetrics.push(dataItem.value || null); }
          else{
            rowMetrics.push(null);
          }
          
        }
        dimMetrics.push(rowMetrics);
        
      }

      // create dataset
      echartOptions.dataset=[
        {
          source: dimMetrics
        }
      ];

      // series data update
      echartOptions.series=[
        {
          type: 'map',
          roam: true,
          geoIndex: 0,
          colorBy:'data',
          map: selectCountry,
          animation: true,
  
          emphasis: {
            label: {
              show: true
            }
          },
        }
      ];
     
      // update visual map
      echartOptions.visualMap={
        type: 'piecewise',
        bottom: '0%',  
        left: 'right',
        orient: 'horizontal',
        itemWidth: 10, 
        itemHeight: 10, 
        textStyle: {
          fontSize: 10,
           fontFamily:'Merriweather'
        },
        categories: [
          "1","2","3","4","5"
      ],
        dimension: dbdhsRegionIndex+1,
        inRange: {
          color: [...DEFAULT_FORM_DATA.colorRange],
          symbolSize: 30,
          symbol: 'square'
        
        },
        outOfRange: { color: 'white' },
        formatter(value: any) { return `DBHDS Region ${value}`; },
        selectedMode: 'multiple'
      };
    
    }
  
    return {
      formData,
      width,
      height,
      echartOptions,
      setDataMask,
      labelMap,
      groupby,
      enablePopUpDrilldown,
      popUpGroupBy,
      popUpMetrics,
      popUpDropdownColumns,
      columnConfig
    };
}
